export const PRODUCT_KEYS = {
  FEED: 'feed',
  IGAMING_SEARCH: 'igaming_search',
  SPORTS_SEARCH: 'sports_search',
  NATIVE_SPORTSBOOK: 'native_sportsbook',
  PREPACKS: 'prepacks',
  AFFILIATE_LINKS: 'affiliate_links',
  MARKET_INSIGHTS: 'market_insights',
  // An add-on with no page of its own: Growth's bet-by-bet attribution table.
  ATTRIBUTION_DETAILS: 'attribution_details',
}

export const STUDIO_PRODUCTS = {
  [PRODUCT_KEYS.FEED]: {
    key: PRODUCT_KEYS.FEED,
    label: 'Feed',
    name: 'Wager Feed',
    defaultPath: '/dashboard/feed/posts',
  },
  [PRODUCT_KEYS.IGAMING_SEARCH]: {
    key: PRODUCT_KEYS.IGAMING_SEARCH,
    label: 'iGaming',
    name: 'iGaming Search',
    defaultPath: '/dashboard/igaming/rules',
  },
  [PRODUCT_KEYS.SPORTS_SEARCH]: {
    key: PRODUCT_KEYS.SPORTS_SEARCH,
    label: 'Sports Search',
    name: 'Sports Search',
    defaultPath: '/dashboard/sports-search/overview',
  },
  [PRODUCT_KEYS.NATIVE_SPORTSBOOK]: {
    key: PRODUCT_KEYS.NATIVE_SPORTSBOOK,
    label: 'Native Sportsbook',
    name: 'Native Sportsbook',
    defaultPath: '/dashboard/native-sportsbook/manifests',
  },
  [PRODUCT_KEYS.PREPACKS]: {
    key: PRODUCT_KEYS.PREPACKS,
    label: 'Prepacks',
    name: 'Prepacks Studio',
    defaultPath: '/dashboard/prepacks/automations/schedules',
  },
  [PRODUCT_KEYS.MARKET_INSIGHTS]: {
    key: PRODUCT_KEYS.MARKET_INSIGHTS,
    label: 'Market Insights',
    name: 'Market Insights',
    defaultPath: '/dashboard/market-insights/configuration',
  },
  [PRODUCT_KEYS.AFFILIATE_LINKS]: {
    key: PRODUCT_KEYS.AFFILIATE_LINKS,
    label: 'Affiliate links',
    name: 'Affiliate links',
    defaultPath: '/dashboard/affiliate-links/live',
  },
}

export function getProductGrant(org, productKey) {
  const products = org?.products || []
  return products.find((item) => item.key === productKey) || null
}

export function hasProductAction(org, productKey, action = 'view') {
  const product = getProductGrant(org, productKey)
  if (!product) return false

  const actions = product.actions || []
  return actions.includes('*') || actions.includes('admin') || actions.includes(action)
}

export function productName(productKey) {
  return STUDIO_PRODUCTS[productKey]?.name || productKey
}
